import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    output,
    signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TelXLLoadingComponent } from '@dxp/elements';
import { catchError, of, tap } from 'rxjs';
import { VoiceApiService } from '@dxp/core/api';
import { VoiceCallService } from '../../services/voice-call.service';

@Component({
    selector: 'voice-payments',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLLoadingComponent],
    templateUrl: './voice-payments.component.html',
    styleUrl: './voice-payments.component.scss',
})
export class VoicePaymentsComponent {
    readonly #sanitizer = inject(DomSanitizer);
    readonly #voiceCallService = inject(VoiceCallService);
    readonly #voiceApiService = inject(VoiceApiService);
    closeButtonEmitter = output();

    isLoading = signal<boolean>(true);

    closeButtonHandler() {
        this.#voiceApiService
            .completePayment({
                conversationId:
                    this.#voiceCallService.conversation()?.conversationId ?? '',
            })
            .subscribe();
        this.closeButtonEmitter.emit();
    }

    paymentInfo = toSignal(
        this.#voiceApiService
            .processPayment({
                conversationId:
                    this.#voiceCallService.conversation()?.conversationId ?? '',
            })
            .pipe(
                catchError(() => of(null)),
                tap({
                    next: () => {
                        this.isLoading.set(false);
                    },

                    error: () => {
                        this.isLoading.set(false);
                    },
                }),
            ),
    );

    sanitizedUrl = computed<null | SafeResourceUrl>(() => {
        const url = this.paymentInfo()?.url ?? null;
        if (url) {
            return this.#sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        return null;
    });
}
